import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

import { PageLayout } from "../../layouts/PageLayout";
import { CreatePurchaseOrderForm, AddItem } from "../../components/purchaseOrders";
import { CardLayout } from "../../components/cards";
import { Breadcrumb } from "../../components";
import { ActionButton, MTable } from "../../components/v3";
import { Box } from "../../components/elements";
import { purchaseItemcolumnHeaders } from "./constants";
import { Get_Parties } from "../../actions/party";
import { useDispatch, useSelector } from "react-redux";
import { Get_Users } from "../../actions/user";
import { get_date } from "../../components/generalComponets";

export const CreatePurchaseOrder = () => {
  const [purchaseOrderDetails, setPurchaseOrderDetails] = useState({
    vendor: "",
    assignee: "",
    date: get_date(Date.now(), "YYYY-MM-DD"),
    requiredDate: "",
  });
  console.log(`🚀 ~ CreatePurchaseOrder ~ purchaseOrderDetails:`, purchaseOrderDetails);
  const [item, setItem] = useState({});
  const [items, setItems] = useState([]);

  const dispatch = useDispatch();

  const vendors = useSelector((state) => state.party.parties.data);
  const users = useSelector((state) => state.user.users.data);

  // formatting vendors and users to compatible with inputField component
  const formattedVendors = vendors.map((vendor) => {
    return {
      ...vendor,
      label: vendor.name,
      value: vendor.id,
    };
  });
  const formattedUsers = users.map((user) => {
    return {
      ...user,
      label: user.name,
      value: user.id,
    };
  });

  useEffect(() => {
    fetchData();
    setPurchaseOrderDetails({ date: get_date(Date.now(), "YYYY-MM-DD") });
  }, []);

  const fetchData = () => {
    dispatch(Get_Parties({ is_active: true }, () => {}));
    dispatch(Get_Users({}, () => {}));
  };

  // function for updating purchaseOrderDetails
  const updateDetailsState = (event) => {
    const { name, value } = event.target;
    setPurchaseOrderDetails({ ...purchaseOrderDetails, [name]: value });
  };

  // function for updating item
  const updateItemState = (event) => {
    const { name, value } = event.target;
    setItem({ ...item, [name]: value });
  };

  const handleAddItem = () => {
    const currentItem = {
      id: Math.random(), // for displaying row in DataGrid table
      name: item.name,
      quantity: item.quantity,
      price: item.price,
    };
    // setting total price
    currentItem.total = currentItem.quantity * currentItem.price;

    setItem({}); //reseting item input fields
    setItems([...items, currentItem]);
  };

  const handleSaveAsDraft = () => {
    console.log(items);
  };

  const handleRequestForApproval = () => {
    console.log(items);
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <CardLayout>
            <Breadcrumb title="Create Purchase Order" />
          </CardLayout>
        </Col>

        <Col xl={12}>
          <CardLayout>
            <CreatePurchaseOrderForm
              details={purchaseOrderDetails}
              vendors={formattedVendors}
              users={formattedUsers}
              onChange={updateDetailsState}
            />

            <AddItem item={item} onChange={updateItemState} onSubmit={handleAddItem} />

            {items.length > 0 && (
              <Box className={"mt-4"}>
                <MTable columnHeaders={purchaseItemcolumnHeaders} tableRows={items} />
              </Box>
            )}

            <Box className={"d-flex justify-content-end gap-1"}>
              <ActionButton buttonText="Save as Draft" color="primary" onButtonClick={handleSaveAsDraft} />
              <ActionButton buttonText="Request for Approval" color="primary" onButtonClick={handleRequestForApproval} />
            </Box>
          </CardLayout>
        </Col>
      </Row>
    </PageLayout>
  );
};
